<template>
    <div class="modal modal--rebrand over-all" id="modalReportProfile" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="title">{{ translate.account.report }}</span>
                </div>

                <div class="modal-body" v-if="!submitted">

                    <!-- type of issue start -->
                    <div class="form-group">

                        <span class="error-input-container dropdown-with-info-container-v2">
                            <select class="form-control-v2" v-model="issueTypeSelected" :class="{'error': !reportIsValid && !(issueTypeSelected >= 0)}">
                                <option disabled hidden value="-1">{{ translate.account.placeholder.issueType }}</option>
                                <option v-for="issue in translate.account.issueTypes" :value="issue.id">{{ issue.title }}</option>
                            </select>

                            <error-component-with-icon v-if="!reportIsValid && !(issueTypeSelected >= 0)"
                                                       :message="translate.account.validation.issueType">
                            </error-component-with-icon>

                        </span>

                    </div>
                    <!-- type of issue end -->

                    <!-- description start -->
                    <div class="form-group">

                            <textarea type="text" class="form-control-v2" rows="4"
                                      :placeholder="descriptionPlaceholder"
                                      v-model.trim="description">
                            </textarea>

                        <p>
                            {{translate.home.charactersLeft1}} {{ descriptionCharsLeft }}
                            {{translate.home.charactersLeft2}}
                        </p>

                        <error-component-with-icon v-if="!reportIsValid && !customIssueIsOk"
                                                   :message="translate.account.validation.issueDescribe">
                        </error-component-with-icon>
                    </div>
                    <!-- description end -->

                    <!-- email start -->
                    <div class="input-group">

                        <input class="form-control-v2" id="inputEmail"
                               :placeholder="translate.account.placeholder.yourEmailOptional" type="email"
                               v-model="email">

                    </div>
                    <!-- email end -->

                </div>

                <div class="modal-body" v-if="submitted">
                    <p>{{translate.account.successMessage.issueSubmitted}}</p>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-rebrand-primary btn-rebrand-sm w-full disable-dark"
                            v-if="!submitted"
                            @click.stop="submitReport"
                            ref="submit">
                        {{translate.home.submit}}
                    </button>

                    <button type="button" class="btn btn-rebrand-grey-outline btn-rebrand-sm w-full"
                            v-if="submitted"
                            data-dismiss="modal"
                            ref="close">
                        {{translate.home.close}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const data = () => ({
        issueTypeSelected: -1,
        description: '',
        email: '',
        reportIsValid: true,
        submitted: false,
        descriptionMaxLength: 500,
        eventResettingForm: 'hidden.bs.modal',
        selectorResettingForm: '#modalReportProfile',
        shouldResetForm: null,
    });

    async function submitReport() {
        if (!this.isReportValid()) {
            return;
        }

        const [err, response] = await to(
            api.user.report.post({
                reported_user_id: this.reportedUserId,
                issue_type: this.issueTypeSelected,
                issue_description: this.description,
                reporter_email: this.email
            })
        );

        if (err || _.get(response, 'data.result.error', false)) {
            return toastr.error(this.translate.home.errorCommon);
        }

        if (_.get(response, "data.result.report_id", 0) > 0) {
            this.submitted = true;
        }
    }

    function isReportValid() {
        this.reportIsValid = this.issueTypeSelected >= 0 && this.customIssueIsOk;

        return this.reportIsValid;
    }

    function resetForm() {
        this.submitted = false;
        this.issueTypeSelected = -1;
        this.description = '';
        this.email = '';
        this.shouldResetForm = false;
    }

    export default {
        props: {
            reportedUserId: Number,
        },
        data,
        mounted() {
            this.shouldResetForm = false;
            $(this.selectorResettingForm).on(this.eventResettingForm, () => {
                this.shouldResetForm = true;
            });
        },
        beforeDestroy() {
            window.clearModalFade();
        },
        computed: {
            issueTypes() {
                return this.translate.account.issueTypes;
            },
            issueSelected() {
                return this.issueTypeSelected >= 0
                    ? _.get(_.filter(this.translate.account.issueTypes, {id: this.issueTypeSelected}), '0.title', '')
                    : _.get(this, 'translate.account.placeholder.issueType');
            },
            descriptionPlaceholder() {
                return this.issueTypeSelected === constants.issue_type.OTHER
                    ? _.get(this, 'translate.account.placeholder.issueDescribe')
                    : _.get(this, 'translate.account.placeholder.issueDescribe') + ' (optional)';
            },
            descriptionCharsLeft() {
                return this.descriptionMaxLength - _.get(this.description, 'length', 0);
            },
            customIssueIsOk() {
                return this.issueTypeSelected === constants.issue_type.OTHER
                    ? (!!this.description.length)
                    : true;
            },
            ...mapState(['translate']),
        },
        watch: {
            descriptionCharsLeft(value) {
                if (value <= -1) {
                    this.description = this.description.substr(0, this.descriptionMaxLength);
                }
            },
            shouldResetForm(value) {
                if (value) {
                    this.resetForm();
                }
            }
        },
        methods: {
            submitReport,
            resetForm,
            isReportValid
        }
    };
</script>
